import { getElement } from '@stencil/core';
export function Consumes(context) {
  return (target, propertyKey) => {
    const contextKey = context !== null && context !== void 0 ? context : propertyKey;
    const { componentWillLoad, connectedCallback, disconnectedCallback } = target;
    target.__syContextConsumesKeys = target.__syContextConsumesKeys || [];
    if (!target.__syContextConsumesKeys.find(el => el.contextKey == contextKey)) {
      target.__syContextConsumesKeys.push({ contextKey, propertyKey });
    }
    target.__syContextConsumesMount = function () {
      const element = getHostElement(this);
      this.__syContextConsumesElements = this.__syContextConsumesElements || {};
      this.__syContextConsumesKeys.forEach(key => {
        if (!this.__syContextConsumesElements[key.contextKey]) {
          this.__syContextConsumesElements[key.contextKey] = {
            key,
            changeValue: newValue => {
              this[key.propertyKey] = newValue;
            },
          };
        }
      });
      this.__syContextConsumesKeys.forEach(key => {
        element === null || element === void 0 ? void 0 : element.dispatchEvent(new CustomEvent('syContextConsumerDidSubscribe', {
          detail: {
            context: key.contextKey,
            el: this.__syContextConsumesElements[key.contextKey],
          },
          bubbles: true,
          composed: true,
        }));
      });
    };
    if (!target.__syContextConsumesWrapped) {
      target.__syContextConsumesWrapped = true;
      target.componentWillLoad = async function () {
        const hookReturn = componentWillLoad && componentWillLoad.call(this);
        this.__syContextConsumesMount();
        return hookReturn;
      };
      target.connectedCallback = async function () {
        const hookReturn = connectedCallback && connectedCallback.call(this);
        this.__syContextConsumesMount();
        return hookReturn;
      };
      target.disconnectedCallback = async function () {
        const hookReturn = disconnectedCallback && disconnectedCallback.call(this);
        this.__syContextConsumesKeys.forEach(key => {
          var _a, _b;
          if ((_a = this.__syContextConsumesElements[key.contextKey]) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
            (_b = this.__syContextConsumesElements[key.contextKey]) === null || _b === void 0 ? void 0 : _b.unsubscribe();
          }
        });
        return hookReturn;
      };
    }
  };
}
export function getHostElement(component) {
  try {
    return getElement(component);
  }
  catch (e) {
    return null;
  }
}
